import { Box, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import SharedDialog from '../../../../shared/components/Dialog'
import NoInternetGif from '../../../../assets/images/nointernet.gif'

const NoInternet = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine)

  const updateNetwork = () => {
    setIsOnline(navigator.onLine)
  }

  useEffect(() => {
    window.addEventListener('online', updateNetwork)
    window.addEventListener('offline', updateNetwork)

    return () => {
      window.removeEventListener('online', updateNetwork)
      window.removeEventListener('offline', updateNetwork)
    }
  }, [])

  const handleCloseDialog = () => {
    setIsOnline(true)
  }

  return (
    <SharedDialog variant="content" open={!isOnline} onClose={handleCloseDialog} width={436} height={460}>
      <Box display="flex" flexDirection="column" alignItems="center" sx={{ m: 2, textAlign: 'center' }}>
        <img src={NoInternetGif} alt="No Internet" />
        <Typography sx={{ fontSize: '24px', fontWeight: 700 }}>No Internet</Typography>
      </Box>
    </SharedDialog>
  )
}

export default NoInternet
